import type { ReactNode } from 'react';

import {
  Doc as DocIcon,
  Document,
  Folder,
  Pdf as PdfIcon,
  Ppt as PptIcon,
  Xls as XlsIcon,
} from '@mint-lib/icons';

import type { RagTableType } from '../../../../types/rag.js';

const iconDict: Record<string, ReactNode> = {
  docx: <DocIcon className="flex shrink-0" data-testid="doc-file-icon" />,
  pdf: <PdfIcon className="flex shrink-0" data-testid="pdf-file-icon" />,
  xlsx: <XlsIcon className="flex shrink-0" data-testid="xls-file-icon" />,
  pptx: <PptIcon className="flex shrink-0" data-testid="ppt-file-icon" />,
  txt: (
    <Document
      className="flex shrink-0 fill-icon-primary"
      data-testid="txt-file-icon"
    />
  ),
  folder: (
    <Folder
      className="flex shrink-0 fill-icon-primary"
      data-testid="folder-icon"
    />
  ),
};

const FileIcon = ({ type }: { type: RagTableType['fileType'] }) => {
  return iconDict[type] ?? iconDict['txt'];
};

export { FileIcon };
